/** Categories */

const originalCategory = {
	name: null,
	description: null,
	slug: null,
	parent_id: null,
}

const SurveyCategoryState = {
	url: '/surveymanagement/categories',
	urlSingular: '/surveymanagement/category',
	categories: [],
	currentCategory: { ...originalCategory },
	query: {
		size: 10,
		from: 0,
	},
	filters: {
		searchQuery: '',
	},
	sortBy: {
		field: 'name.raw',
		direction: 'asc',
	},
	error: null,
}

export { originalCategory, SurveyCategoryState }
